<template>
  <!-- AI F §1.1.5 — colors: indexing blue, active green, failed red, archived grey -->
  <span
    class="inline-block rounded-full px-2 py-0.5 text-xs font-medium"
    :class="colorClass"
  >
    {{ $t(`KNOWLEDGE_BASE.STATUSES.${status.toUpperCase()}`) }}
  </span>
</template>

<script>
const COLORS = {
  indexing: 'bg-blue-100 text-blue-700',
  searching: 'bg-blue-100 text-blue-700',
  active: 'bg-green-100 text-green-700',
  failed: 'bg-red-100 text-red-700',
  archived: 'bg-slate-100 text-slate-600',
  expired: 'bg-slate-100 text-slate-600',
};

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    colorClass() {
      return COLORS[this.status] || COLORS.archived;
    },
  },
};
</script>
